export default __webpack_public_path__ + "i18n/translations/translation-th.f1595d24.json";